"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'ActivityDetail',
  props: {
    activityData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    // 解析活动图片
    activityImages: function activityImages() {
      return this.parseImageData(this.activityData.activityImg);
    },
    // 解析扩展费用列表
    activityExtList: function activityExtList() {
      return this.parseExtList(this.activityData.marketActivityExtList);
    },
    // 解析表单配置
    formConfigList: function formConfigList() {
      return this.parseFormConfig(this.activityData.setting);
    },
    // 解析详情弹幕配置
    bulletScreenList: function bulletScreenList() {
      return this.parseBulletScreen(this.activityData.bulletScreen);
    }
  },
  methods: {
    /**
     * 解析图片数据
     */
    parseImageData: function parseImageData(imageData) {
      if (!imageData) return [];
      try {
        // 如果是JSON字符串，解析为数组
        if (typeof imageData === 'string') {
          var parsed = JSON.parse(imageData);
          return Array.isArray(parsed) ? parsed : [];
        }
        // 如果是数组，直接返回
        if (Array.isArray(imageData)) {
          return imageData;
        }
        // 如果是逗号分隔的字符串，分割为数组
        if (typeof imageData === 'string' && imageData.includes(',')) {
          return imageData.split(',').filter(function (img) {
            return img.trim();
          });
        }
        return [];
      } catch (error) {
        console.error('解析图片数据失败:', error);
        return [];
      }
    },
    /**
     * 解析扩展费用列表
     */
    parseExtList: function parseExtList(extList) {
      if (!Array.isArray(extList)) return [];
      return extList.filter(function (item) {
        return !item.isDel;
      });
    },
    /**
     * 判断扩展费用是否已设置金额，0 和负数均为有效金额
     */
    hasFeeAmount: function hasFeeAmount(fee) {
      return fee && fee.extFee !== undefined && fee.extFee !== null && fee.extFee !== '';
    },
    // 单独配置抽成时，后端可能同时返回 extFee=0，不能按免费费用展示
    hasCommissionOnly: function hasCommissionOnly(fee) {
      if (!fee || fee.negotiable === 1) return false;
      var commissionEnabled = fee.commissionStatusExt === 1 || fee.commissionStatusExt === true;
      var commissionAmount = fee.commissionExt !== undefined && fee.commissionExt !== null && Number(fee.commissionExt) > 0;
      return Number(fee.extFee) === 0 && (commissionEnabled || commissionAmount);
    },
    /**
     * 判断是否为有效的区间费用
     */
    hasRangeFee: function hasRangeFee(fee) {
      return this.hasFeeAmount(fee) && Number(fee.extFee) >= 0 && fee.extFeeMax !== undefined && fee.extFeeMax !== null && fee.extFeeMax !== '' && Number(fee.extFeeMax) > Number(fee.extFee);
    },
    /**
     * 负数金额按补贴金额展示
     */
    formatFeeAmount: function formatFeeAmount(value) {
      var amount = Number(value);
      if (!Number.isFinite(amount)) return value;
      return amount < 0 ? "\u8865\u8D34".concat(Math.abs(amount)) : "".concat(amount);
    },
    formatSingleFee: function formatSingleFee(value) {
      var amount = Number(value);
      if (!Number.isFinite(amount)) return value;
      if (amount < 0) return "\u8865\u8D34".concat(Math.abs(amount), "\u5143");
      if (amount === 0) return '免费活动';
      return "".concat(amount, "\u5143");
    },
    getFeeTypeText: function getFeeTypeText(fee) {
      var amount = Number(fee.extFee);
      if (amount < 0) return '补贴';
      if (amount === 0) return '免费';
      return fee.extType === 0 ? '摊位费用' : '补充费用';
    },
    getFeeTypeTag: function getFeeTypeTag(fee) {
      var amount = Number(fee.extFee);
      if (amount < 0) return 'success';
      if (amount === 0) return 'info';
      return fee.extType === 0 ? 'primary' : 'warning';
    },
    /**
     * 解析表单配置
     */
    parseFormConfig: function parseFormConfig(settingJson) {
      if (!settingJson) return [];
      try {
        var parsedData = JSON.parse(settingJson);
        if (_typeof(parsedData) === 'object') {
          // 表单配置选项映射
          var settingOptions = {
            address: '常住地址',
            activity_record: '市集经验',
            goods_img: '商品图片和摆台图',
            device_info: '用电需求',
            stall_introduce: '摊位名或品牌名',
            introduce: '一句话介绍自己',
            id_card: '身份证号',
            id_card_photo: '身份证图片',
            business_food_license: '营业执照或食品经营许可证',
            health_certificate: '健康证',
            max_kw: '最大用电功率(根据用电需求开关配置)',
            goods: '商品名称',
            sales_type: '售卖商品类型',
            name: '姓名',
            phone: '手机号',
            wechat: '微信号',
            wechat_photo: '微信二维码照片',
            need_count: '申请摊位数'
          };

          // 返回已选中的配置项
          return Object.keys(parsedData).filter(function (key) {
            return parsedData[key] === true && settingOptions[key];
          }).map(function (key) {
            return {
              key: key,
              label: settingOptions[key]
            };
          });
        }
        return [];
      } catch (error) {
        console.error('解析表单配置失败:', error);
        return [];
      }
    },
    /**
     * 解析详情弹幕配置
     */
    parseBulletScreen: function parseBulletScreen(bulletScreen) {
      if (!bulletScreen) return [];
      if (Array.isArray(bulletScreen)) {
        return bulletScreen.map(function (item) {
          return typeof item === 'string' ? item.trim() : item;
        }).filter(function (item) {
          return item !== undefined && item !== null && String(item).trim() !== '';
        });
      }
      if (typeof bulletScreen === 'string') {
        var trimmed = bulletScreen.trim();
        if (!trimmed) return [];
        try {
          var parsed = JSON.parse(trimmed);
          if (Array.isArray(parsed)) {
            return parsed.map(function (item) {
              return typeof item === 'string' ? item.trim() : item;
            }).filter(function (item) {
              return item !== undefined && item !== null && String(item).trim() !== '';
            });
          }
        } catch (error) {
          // ignore parse error
        }
        return trimmed.split(',').map(function (item) {
          return item.trim();
        }).filter(function (item) {
          return item;
        });
      }
      return [];
    },
    /**
     * 获取状态类型
     */
    getStatusType: function getStatusType(status) {
      var statusMap = {
        0: 'success',
        1: 'danger'
      };
      return statusMap[status] || 'info';
    },
    /**
     * 获取状态文本
     */
    getStatusText: function getStatusText(status) {
      var statusMap = {
        0: '正常',
        1: '下架'
      };
      return statusMap[status] || '未知';
    },
    /**
     * 格式化日期时间
     */
    formatDateTime: function formatDateTime(dateTime) {
      if (!dateTime) return '暂无';
      return new Date(dateTime).toLocaleString('zh-CN');
    },
    /**
     * 格式化时间范围
     */
    formatTimeRange: function formatTimeRange(startTime, endTime) {
      if (!startTime || !endTime) return '暂无';
      var start = new Date(startTime).toLocaleString('zh-CN');
      var end = new Date(endTime).toLocaleString('zh-CN');
      return "".concat(start, " - ").concat(end);
    },
    /**
     * 获取进程状态类型
     */
    getProcessStatusType: function getProcessStatusType(status) {
      var statusMap = {
        0: 'info',
        // 未开始
        1: 'warning',
        // 进行中
        2: 'success',
        // 已结束
        3: 'danger' // 已取消
      };
      return statusMap[status] || 'info';
    },
    /**
     * 获取进程状态名称
     */
    getProcessStatusName: function getProcessStatusName(status) {
      var statusMap = {
        0: '未开始',
        1: '进行中',
        2: '已结束',
        3: '已取消'
      };
      return statusMap[status] || '未知';
    }
  }
};